<template lang="pug">
.buscaCar-container
    el-input#car-parcela.input(
        v-if='visivel',
        v-model='car',
        :placeholder="$t('mensagens.menuMapa.placeholder.informeCarOuParcela')",
        @keyup.enter.native='fazerPesquisa',
        @keyup.escape.native='showInput(null)',
        clearable,
        ref='inputForm'
    )

    BaseButton#botao-busca-car(
        type='primary',
        :title="$t('mensagens.menuMapa.placeholder.buscarCarOuParcela')",
        icon='el-icon-search',
        @click='showInput(null)',
        @keyup.escape.native='showInput(false)'
    )
</template>

<script>
import store from '@/store';
import carService from '@/services/car/CarService';
import mapaEstilos from '@/utils/mapa/mapa.estilos';
import Mapa from '@/utils/mapa/mapa.service';
import EventBus from '@/utils/eventBus';
import SigefService from '@/services/SigefService';
import formatters from '@/utils/formatters';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';
import LaudosService from '@/services/LaudosService';

export default {
    name: 'BuscaCar',

    components: {
        BaseButton
    },

    props: {
        mapa: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            visivel: false,
            car: '',
            elegibilidadeRenovabio: null
        };
    },
    watch: {
        car: function (value) {
            if (value.length > 0) {
                let mascara = '';
                value = value.replace(/[^\w\s]/gi, '');

                if (value.length <= 12) {
                    mascara = formatters.formatCarEstadualMT(value);
                } else if (value.length <= 32) {
                    mascara = formatters.formatCodigoParcela(value);
                } else {
                    mascara = formatters.formatCar(value);
                }
                this.car = mascara;
            }
        }
    },

    methods: {
        fecharInputAoClicarFora(event) {
            if (!this.$el.contains(event.target)) {
                this.showInput(false);
            }
        },

        showInput(visivel) {
            this.visivel = !this.visivel;
            if (this.visivel) {
                document.body.addEventListener(
                    'click',
                    this.fecharInputAoClicarFora
                );
                this.$nextTick(() => {
                    this.$refs.inputForm.focus();
                });
            } else {
                document.body.removeEventListener(
                    'click',
                    this.fecharInputAoClicarFora
                );
            }
        },

        fazerPesquisa() {
            if (!this.car && this.car === '') {
                this.$notify.error({
                    message: this.$t('mensagens.menuMapa.notificacoes.informeCarOuParcela')
                });
            }
            if (this.car.length === 43 || (this.car.length <= 13 && this.car.substring(0, 2) === 'MT')) {
                this.buscarCar();
            } else {
                this.buscarSigef();
            }

        },
        async buscarCar() {
            try {
                const { data } = await carService.findByCodigos(Array(this.car));
                
                await LaudosService.getElegibilidadeRenovabio(this.car)
                .then(({ data }) => {
                    this.elegibilidadeRenovabio = data.elegivel;
                });

                this.mostrarTerritorioNoMapa(data.data[0].geometria, this.car);
                return;
            } catch {
                this.$notify.error({
                    message: this.$t('mensagens.menuMapa.notificacoes.naoFoiPossivelConsultarCar')
                });
                this.clearLayers();
            }
        },
        async buscarSigef() {
            try {
                const { data } = await SigefService.buscarGeometriaParcela(
                    this.car
                );
                if (data !== '') {
                    const geometriaSigef = JSON.parse(data);

                    this.mostrarTerritorioNoMapa(geometriaSigef, this.car);
                    return;
                } else {
                    this.$notify.warning(
                        this.$t('mensagens.menuMapa.notificacoes.parcelaNaoEncontrada')
                    );
                    this.clearLayers();
                    return;
                }
            } catch (error) {
                this.$notify.error({
                    message: this.$t('mensagens.menuMapa.notificacoes.parcelaNaoEncontrada')
                });
                this.clearLayers();
            }
        },

        clearLayers() {
            if (this.geometria) {
                this.mapa.removeLayer(this.geometria);
                this.geometria = null;
                store.dispatch('setCarSelecionadoNaPopup', null);
            }
        },

        mostrarTerritorioNoMapa(geometria, identificadorGeometria) {
            this.geometria = Mapa.criarGeoJSON(
                geometria,
                mapaEstilos.Geometria.car
            );
            this.geometria.identificadorGeometria = identificadorGeometria;
            this.mapa.addLayer(this.geometria);
            var bounds = this.geometria.getBounds();

            // Fit the map to the polygon bounds
            this.mapa.fitBounds(bounds);

            let layer = Object.values(this.geometria._layers)[0];
            layer.layerType = 'polygon';
            layer.layerInfo = {
                origem: 'BUSCA_CAR',
                codigo: this.car,
                elegivel_renovabio: this.elegibilidadeRenovabio
            };
            EventBus.$emit('retorna-geometria-car', layer);
        }
    }
};
</script>

<style lang="scss">
#botao-busca-car {
    width: 31px !important;
    height: 31px !important;
    min-width: 31px !important;
    color: var(--black);
    padding: 0 !important;
}

.buscaCar-container {
    display: flex;
    height: 31px;

    .input input {
        height: 31px;
        width: 300px;
        border-radius: 0;
    }
}
</style>
